export default __webpack_public_path__ + "static/media/rootl.05567794.jpg";